var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "field", class: { "field--error": _vm.showErrors } },
    [
      _c("label", {
        staticClass: "field__label",
        attrs: { for: "field_label", for: _vm.id },
        domProps: { textContent: _vm._s(_vm.label) }
      }),
      _vm._v(" "),
      _c(
        "input",
        _vm._g(
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputValue,
                expression: "inputValue"
              }
            ],
            staticClass: "field__input",
            attrs: {
              type: "text",
              id: "field_label",
              id: _vm.id,
              name: _vm.id,
              placeholder: _vm.placeholder
            },
            domProps: { value: _vm.inputValue },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.inputValue = $event.target.value
              }
            }
          },
          _vm.listeners
        )
      ),
      _vm._v(" "),
      _vm.showErrors
        ? _c("gc-list", {
            attrs: { "display-errors": true, items: _vm.errors }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }